// extracted by mini-css-extract-plugin
module.exports = {"main":"ContactForm-module__5sEU1G__main","required":"ContactForm-module__5sEU1G__required","bold":"ContactForm-module__5sEU1G__bold"};